export interface KakaoSdk {
  init: (appKey: string) => void;
  isInitialized: () => boolean;
  Share: {
    sendDefault: (settings: {
      buttons: { link: KakaoLink; title: string }[];
      content: {
        description?: string;
        imageHeight: number;
        imageUrl?: string;
        imageWidth: number;
        link: KakaoLink;
        title?: string;
      };
      objectType: 'feed';
      serverCallbackArgs?: Record<string, unknown>;
    }) => void;
  };
}

interface KakaoLink {
  androidExecutionParams?: string;
  iosExecutionParams?: string;
  mobileWebUrl?: string;
  webUrl?: string;
}

declare global {
  interface Window {
    Kakao?: KakaoSdk;
  }
}

// 버전과 SRI 는 짝이다 — 버전을 올리면 https://developers.kakao.com/docs/ko/javascript/download 의 해시로 같이 바꾼다
const KAKAO_SDK = {
  integrity: 'sha384-oroumrnFVE0xtgqyDZJARgERibXg2C28380uaUZz2kHDS5CR7tu20eGiOU6GkTpy',
  src: 'https://t1.kakaocdn.net/kakao_js_sdk/2.8.3/kakao.min.js',
};

let kakaoSdkPromise: null | Promise<KakaoSdk> = null;

export const loadKakaoSdk = (): Promise<KakaoSdk> => {
  if (window.Kakao) {
    return Promise.resolve(window.Kakao);
  }
  if (kakaoSdkPromise) {
    return kakaoSdkPromise;
  }
  const script = document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.integrity = KAKAO_SDK.integrity;
  script.src = KAKAO_SDK.src;
  const pending = new Promise<KakaoSdk>((resolve, reject) => {
    const fail = () => {
      kakaoSdkPromise = null;
      script.remove();
      reject(new Error('카카오 SDK 를 불러오지 못했다'));
    };
    script.addEventListener('error', fail);
    script.addEventListener('load', () => (window.Kakao ? resolve(window.Kakao) : fail()));
  });
  kakaoSdkPromise = pending;
  document.head.append(script);
  return pending;
};
